import { Injectable } from '@angular/core';
import { ConfigurationService } from './configuration.service';
import { NotifMessageService } from './notifmessage.service';
import { Moment } from 'moment';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {


  constructor(private configService: ConfigurationService,
    private notifService: NotifMessageService) { }

  /**
   * return end of month 
   * example '2020-04-16'
   * return '2020-04-30'
   */
  getMonthEnd(date: Moment) {
    return date.clone().endOf('month');
  }


  /**
   * return start of month 
   * example '2020-04-16'
   * return '2020-04-01'
   */
  getMonthBegin(date: Moment) {
    return date.clone().startOf('month');
  }

  /**
   * update "windowBegin" & "windowEnd" attorbutes of criteria object
   * 
   * @param criteria 
   */
  updateCriteriaWindow(criteria) {
    if (criteria) {
      criteria.windowBegin ? criteria.windowBegin = moment.utc(criteria.windowBegin).format() : null;
      criteria.windowEnd ? criteria.windowEnd = moment.utc(criteria.windowEnd).format() : null;
    }
  }


  /**
   * update "from" & "to" attributes of criteria object
   * 
   * @param criteria 
   */
  updateCriteriaWindowFromTo(criteria) {
    if (criteria) {
      criteria.from ? criteria.from = moment.utc(criteria.from).format() : null;
      criteria.to ? criteria.to =  moment.utc(criteria.to).format() : null;
    }
  }
}
